/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElStepperComponent } from './stepper.component';
import { ElStepComponent } from './step.component';
import { ElStepperNextDirective, ElStepperPreviousDirective } from './stepper-button.directive';
import { ElIconModule } from '../icon/icon.module';

@NgModule({
  imports: [
    ElSharedModule,
    ElIconModule,
  ],
  declarations: [
    ElStepperComponent,
    ElStepComponent,
    ElStepperNextDirective,
    ElStepperPreviousDirective,
  ],
  exports: [
    ElStepperComponent,
    ElStepComponent,
    ElStepperNextDirective,
    ElStepperPreviousDirective,
  ],
})
export class ElStepperModule {
}
